import { inject, Injectable } from '@angular/core';
import { ApiService } from '@beautyapp/core';
import { Observable } from 'rxjs';
import { ConsentHistoryQuery, ConsentHistoryResponse } from './user-consent-history.types';

// beaut-256 — reads the centralized consent/verification history for one customer.
@Injectable({ providedIn: 'root' })
export class UserConsentHistoryService {
  private api = inject(ApiService);

  getHistory(userId: string, params: ConsentHistoryQuery): Observable<ConsentHistoryResponse> {
    return this.api.get<ConsentHistoryResponse>(`user-consent-history/${userId}`, params);
  }
}
